import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';

import BackIcon from '@material-ui/icons/ArrowBack';
import Paper from '@material-ui/core/Paper';

import Icon from '@components/Icon/Icon';
import Tabs from '../Tabs/Tabs';

import {
  filingDate,
  name,
  caseNumber,
} from '@selectors/caseDetails';

import { tabs } from '@selectors/caseMenu';

import { isGreaterThanMobile } from '@selectors/browser';

import './CaseMenu.scss';

const CaseMenu = ({
  caseId,
  caseNumber,
  filingDate,
  isInquiry,
  isMobile,
  name,
  tabs,
}) => (
  <div className="case-menu">
    <Paper className="case-menu__top-bar">
      <div className="case-menu__main-row">
        <RouterLink to="/cases">
          <Icon className="case-menu__back-icon">
            <BackIcon />
          </Icon>
        </RouterLink>
        <div className="case-menu__name">
          {name}
        </div>
        {!isMobile && (
          <div className="case-menu__details-container">
            <div className="case-menu__details">
              {caseNumber}
            </div>
            <div className="case-menu__details">
              {moment(filingDate).format('L')}
            </div>
          </div>
        )}
      </div>
      <div className="case-menu__action-bar">
        <div className="case-menu__tabs">
          <Tabs data={tabs} />
        </div>
        {!isMobile && !isInquiry && (
          <div className="case-menu__inquiry-button-wrapper">
            <RouterLink
              to={`/cases/${caseId}/inquiry`}
              className="link case-menu__inquiry-button"
            >
              Submit an inquiry
            </RouterLink>
          </div>
        )}
      </div>
    </Paper>
    {isMobile && (
      <Paper className="case-menu__details-extra-container">
        <div className="case-menu__inquiry-button-wrapper">
          {!isInquiry && (
            <RouterLink
              to={`/cases/${caseId}/inquiry`}
              className="link case-menu__inquiry-button"
            >
              Submit an inquiry
            </RouterLink>
          )}
        </div>
        <div className="case-menu__details-container">
          <div className="case-menu__details">
            {caseNumber}
          </div>
          <div className="case-menu__details">
            {filingDate}
          </div>
        </div>
      </Paper>
    )}
  </div>
);

CaseMenu.propTypes = {
  caseId: PropTypes.string.isRequired,
  caseNumber: PropTypes.string.isRequired,
  filingDate: PropTypes.string.isRequired,
  isInquiry: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    path: PropTypes.string,
    title: PropTypes.string,
  })).isRequired,
};

const mapStateToProps = state => ({
  caseNumber: caseNumber(state),
  filingDate: filingDate(state),
  isMobile: !isGreaterThanMobile(state),
  name: name(state),
  tabs: tabs(state),
});

export default connect(mapStateToProps)(CaseMenu);



// WEBPACK FOOTER //
// ./src/routes/Case/containers/CaseMenu/CaseMenu.js